<template>
    <el-card class="box-card">
        <div style="height: 380px;">
            <h4 style="margin: 20px 0;">
                # 金额统计
            </h4>
            <div id="my-canvas" class="chart-container"></div>
        </div>
    </el-card>
</template>

<script>
// 引入 ECharts 核心库
import * as echarts from 'echarts';

export default {
    name: 'UserActionsChart',
    props: {
        rechDataList: {
            type: Array,
            default: () => [
                { title: '充值金额', key: 'rechargeAmount' },
                { title: '礼物金额', key: 'giftAmount' },
                { title: '礼物平台金额', key: 'platformAmount' },
            ]
        },
        statisticsData: {
            type: Object,
            default: () => ({})
        },
        isDark: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // 存储 ECharts 实例
            chartInstance: null
        };
    },
    computed: {
        // 生成图表配置
        chartOption() {
            // 从 rechDataList 中提取 Y 轴显示的标题
            const yAxisData = this.rechDataList.map(item => item.title);
            // 从 mockData 中按顺序提取数值数据
            const seriesData = this.rechDataList.map(item => Number(this.statisticsData[item.key]) || 0);

            return {
                grid: {
                    left: 44,
                    right: 20,
                    top: 0,
                    bottom: 20,
                },
                xAxis: {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        formatter(value, idx) {
                            if (idx === 0) return String(value);
                            return `${Number(value) / 1000}k`;
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: this.isDark ? '#484849' : '#E5E8EF',
                        },
                    },
                },
                yAxis: {
                    type: 'category',
                    data: yAxisData,
                    axisLabel: {
                        show: true,
                        color: this.isDark ? '#C0C4CC' : '#4E5969',
                    },
                    axisTick: {
                        show: true,
                        length: 2,
                        lineStyle: {
                            color: '#A9AEB8',
                        },
                        alignWithLabel: true,
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.isDark ? '#484849' : '#A9AEB8',
                        },
                    },
                },
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    // 优化 tooltip 样式
                    textStyle: {
                        color: this.isDark ? '#fff' : '#333'
                    },
                    backgroundColor: this.isDark ? 'rgba(50,50,50,0.8)' : 'rgba(255,255,255,0.8)'
                },
                series: [
                    {
                        data: seriesData, // 使用动态提取的数值数据
                        type: 'bar',
                        barWidth: 7,
                        itemStyle: {
                            color: '#4086FF',
                            borderRadius: 4,
                        },
                    },
                ],
            };
        }
    },
    watch: {
        // 监听配置变化，更新图表
        chartOption: {
            deep: true,
            handler() {
                this.updateChart();
            }
        },
        // 监听主题变化
        isDark() {
            this.updateChart();
        },
        statisticsData: {
            deep: true,
            handler() {
                this.updateChart();
            }
        }
    },
    mounted() {
        // 组件挂载后初始化图表
        this.initChart();
    },
    beforeDestroy() {
        // 组件销毁前销毁图表实例，防止内存泄漏
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
    },
    methods: {
        // 初始化图表
        initChart() {
            // 获取容器 DOM 元素
            const chartDom = document.getElementById('my-canvas');
            if (!chartDom) return;

            // 初始化 ECharts 实例
            this.chartInstance = echarts.init(chartDom);

            // 设置图表配置并渲染
            this.updateChart();

            // 监听窗口大小变化，自适应调整图表
            window.addEventListener('resize', this.resizeChart);
        },
        // 更新图表配置
        updateChart() {
            if (this.chartInstance) {
                // 设置新的配置项
                this.chartInstance.setOption(this.chartOption, true);
            }
        },
        // 图表自适应
        resizeChart() {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        }
    }
};
</script>

<style scoped lang="scss">
// 给图表容器设置固定高度和宽度
.chart-container {
    width: 100%;
    height: 300px; // 和原设计保持一致
    min-width: 300px; // 最小宽度，防止变形
}
</style>
